import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Account } from 'src/models/account.model';
import { Horse } from 'src/models/horse';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private api: ApiService) {}

  async getAccount(id: number) {
    return this.api.get<Account>(
      `${this.api.endpoints.users}/Get?accountId=${id}`,
    );
  }

  async getAccounts(ids: number[]) {
    return this.api.post<Account[]>(
      `${this.api.endpoints.users}/get`, ids
    );
  }

  async getHorses(accountId: number) {
    return this.api.get<Horse[]>(`${this.api.endpoints.users}/GetHorses?accountId=${accountId}`);
  }

  async updateAccount(user: any) {
    return this.api.put<Account>(
      this.api.endpoints.users + '/updateAccount?id=' + user.id,
      user,
    );
  }

  async deactivateAccount(accountId: number) {
    return this.api.delete(
      `${this.api.endpoints.users}/DeactivateAccount?accountId=${accountId}`,
    );
  }
}
